<template>
  <div class="grid">
    <div class="col-12 p-pt-1">        
            <TabMenu :model="items" />
      </div>
  </div>
</template>
<script>
export default {
  name: 'DomainNavBar',
  props: ['domain'],
  data () {
    return {
      items: [],
    }
  },
  computed: {
    isLoggedIn: function () { return this.$store.state.auth.status.loggedIn }
  },
  created: function() {
    this.items = []
    //console.log(this.domain)




                //{
                //    label: 'Dashboard',
                //    icon: 'pi pi-fw pi-home',
                //    to: '/',
                //    visible: () => this.isLoggedIn
                //},
                //{
                //    label: 'Domains',
                //    icon: 'pi pi-fw pi-calendar',
                //    to: '/domains',
                //    visible: () => this.isLoggedIn
                //},
  
//                 {
//                    label: 'Mail',
//                    icon: 'pi pi-fw pi-envelope',
//                    to: '/domains/' + this.$route.params.domain_id + '/mail/accounts',
//                },
//                {
//                    label: 'DNS',
//                    icon: 'pi pi-fw pi-database',
//                    to: '/domains/' + this.$route.params.domain_id + '/dns/records',
//                },
//                {
//                    label: 'Settings',
//                    icon: 'pi pi-fw pi-cog',
//                    to: '/domains/' + this.$route.params.domain_id + '/settings',
//                },

    
  },
  methods: {
    getServices(attr) {
      if (attr) { 
        const result = attr.find( x => x.key === "services");
        if (result) {
          return result["value"]
        }
      }
    },

  },
  watch: { 
    domain: function(newVal, oldVal) { // watch it
      //const services = this.getServices(newVal.attributes)

      //if (services) {
      //    if (services.mail && services.mail.enabled) {
      //      this.items.push(
      //        {
      //              label: 'Mail',
      //              icon: 'pi pi-fw pi-envelope',
      //              to: '/domains/' + this.$route.params.domain_id + '/mail/accounts',
      //          }
      //        )
      //    }

      //    if (services.dns && services.dns.enabled) {
      //      this.items.push(
      //        {
      //              label: 'DNS',
      //              icon: 'pi pi-fw pi-database',
      //              to: '/domains/' + this.$route.params.domain_id + '/dns/records',
      //          }
      //        )
      //    }
      //}

      //this.items.push(
      //  {
      //      label: 'Settings',
      //      icon: 'pi pi-fw pi-cog',
      //      to: '/domains/' + this.$route.params.domain_id + '/settings',
      //  }
      //)

      this.items = [
        {
            label: 'Mail',
            icon: 'pi pi-fw pi-envelope',
            to: '/domains/' + this.$route.params.domain_id + '/mail',
        },
        {
            label: 'DNS',
            icon: 'pi pi-fw pi-database',
            to: '/domains/' + this.$route.params.domain_id + '/dns/records',
        },
        {
            label: 'Settings',
            icon: 'pi pi-fw pi-cog',
            to: '/domains/' + this.$route.params.domain_id + '/settings',
        },
      ]

      //this.items.push()
    }
  }
}
</script>
<style>

</style>
